var env = process.env.REACT_APP_NODE_ENV || "development";

var config =
{
  development:
  {
    api:
    {
      api_key: "cfc56e4a8faeb1758adc75d99ca08d7f",
      url: "https://api.institutoestradareal.com.br"
    },
    local_storage:
    {
      user: "user_admin_dashboard",
      auth: "auth_admin_dashboard"
    },
    jwt:
    {
      key: "ad944fd450c5b1637d7c67cb8504e548"
    }
  },
  production:
  {
    api:
    {
      api_key: "cfc56e4a8faeb1758adc75d99ca08d7f",
      url: "https://api.institutoestradareal.com.br"
    },
    local_storage:
    {
      user: "user_admin_dashboard",
      auth: "auth_admin_dashboard"
    },
    jwt:
    {
      key: "86012ac3b4a9a90cf4b253c6bed4adf1"
    }
  },
};

module.exports = config[env];
